import { render } from "./PopupUserMenu.vue?vue&type=template&id=51f077fb&scoped=true"
import script from "./PopupUserMenu.vue?vue&type=script&lang=js"
export * from "./PopupUserMenu.vue?vue&type=script&lang=js"

import "./PopupUserMenu.vue?vue&type=style&index=0&id=51f077fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f077fb"]])

export default __exports__